<div>
  <div class="grid place-items-center py-2">
    <img src="assets/images/starlink.svg" alt="Starlink Logo" class="py-2" width="120px" />
  </div>
  <div class="grid py-1 pb-4" [ngClass]="{
      'grid-cols-2': !hasNoBack
    }">
    @if(!hasNoBack){
    <div>
      <span class="text-xs font-medium cursor-pointer" (click)="backHome()">
        <img src="assets/icons/arrow-left.svg" class="inline-flex px-1" [class.rotate-180]="language === 'ar'" />
        {{ "mainBack_btn" | translate }}
      </span>
    </div>
    }
    <div class="flex font-bold justify-end language-container" [ngClass]="hasNoBack ? 'justify-center' : 'justify-end'">
      <p-selectbutton [options]="langs" [(ngModel)]="language" optionLabel="label" optionValue="language"
        aria-labelledby="basic" [allowEmpty]="false" (onChange)="onLangChange($event.value)" />
    </div>
  </div>
</div>